import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const MembershipsPath: MainPath = '/memberships/:id?/:section?/:transitId?/:subsection?';
export const MembershipsStatsPath: MainPath = '/memberships_stats/:section?';
export const TransitsPath: MainPath = '/transits';
export const TariffarioPPUPath: MainPath = '/tariffario_ppu';
export const SogliePPUPath: MainPath = '/check_soglie_ppu';

export const MEMBERSHIPS_TABS = [
  'details',
  'transits',
  'failed_transits',
  'caps',
  'audits',
  'notes',
  'discounts',
] as const;
export const MEMBERSHIPS_STATS_TABS = ['stats', 'caps'] as const;

export const TRANSITS_TABS = ['payments', 'passages', 'discounts'] as const;

export type MembershipsTabs = (typeof MEMBERSHIPS_TABS)[number];
export type MembershipsStatsTabs = (typeof MEMBERSHIPS_STATS_TABS)[number];
export type TransitsTabs = (typeof TRANSITS_TABS)[number];

export const MembershipsRoute: MainNavRoute = {
  path: '/memberships',
  label: 'routes.memberships',
  icon: 'memberships',
  permissions: [PERMISSIONS.MEMBERSHIPS__LIST],
  type: 1,
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-55155/134c3b1faa0347f',
  children: [
    {
      path: ':id',
      disowned: true,
      permissions: [PERMISSIONS.MEMBERSHIPS__DETAILS],
      children: makeChildren<MembershipsTabs>({
        details: {
          path: 'details',
        },
        failed_transits: {
          path: 'failed_transits',
          permissions: [PERMISSIONS.MEMBERSHIPS__TRANSITS],
        },
        caps: {
          path: 'caps',
          permissions: [PERMISSIONS.MEMBERSHIPS__CAPS],
        },
        audits: {
          path: 'audits',
          permissions: [PERMISSIONS.MEMBERSHIPS__AUDITS],
        },
        transits: {
          path: 'transits',
          permissions: [PERMISSIONS.MEMBERSHIPS__TRANSITS],
          children: [
            {
              path: ':transitId',
              children: makeChildren<TransitsTabs>({
                payments: { path: 'payments' },
                passages: { path: 'passages' },
                discounts: { path: 'discounts', permissions: [PERMISSIONS.MEMBERSHIPS__DISCOUNTS] },
              }),
            },
          ],
        },
        notes: {
          path: 'notes',
          permissions: [PERMISSIONS.MEMBERSHIPS__NOTES_VIEW],
        },
        discounts: {
          path: 'discounts',
          permissions: [PERMISSIONS.MEMBERSHIPS__DISCOUNTS],
        },
      }),
    },
  ],
};

export const MembershipsStatsRoute: MainNavRoute = {
  path: '/memberships_stats',
  label: 'routes.memberships_stats',
  icon: 'chart_mixed',
  permissions: [PERMISSIONS.MEMBERSHIPS__STATS],
  type: 1,
  children: makeChildren<MembershipsStatsTabs>({
    stats: { path: 'stats' },
    caps: { path: 'caps' },
  }),
};

export const TransitsRoute: MainNavRoute = {
  path: '/transits',
  label: 'routes.transits',
  icon: 'arrow_long_right',
  permissions: [PERMISSIONS.MEMBERSHIPS__TRANSITS],
  type: 1,
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.MEMBERSHIPS__TRANSITS],
    },
  ],
};

export const TariffarioPPURoute: MainNavRoute = {
  path: '/tariffario_ppu',
  label: 'routes.tariffario_ppu',
  icon: 'money',
  type: 0,
};

export const SogliePPURoute: MainNavRoute = {
  path: '/check_soglie_ppu',
  label: 'routes.check_soglie_ppu',
  // icon: 'money',
  type: 1,
  permissions: [PERMISSIONS.MEMBERSHIPS__CAP_CHECK],
};
